import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import createReporter from '@quick/service-reporter';
import clientApi from '@plus/client-connect';

var TYPE = {
  DEV: 'DEV',
  USER: 'USER',
  ALL: 'ALL'
};

function removeHistoryParameter(parameter) {
  var url = new URL(window.location.href);
  var searchParams = new URLSearchParams(url.search);
  searchParams["delete"](parameter);
  var newUrl = "".concat(url.protocol, "//").concat(url.host).concat(url.pathname, "?").concat(searchParams.toString()).concat(url.hash);
  window.history.replaceState({}, null, newUrl);
}
var Logic = /*#__PURE__*/function () {
  function Logic(options) {
    _classCallCheck(this, Logic);
    this.traceid = Date.now();
    this.prenode = 0;
    this.getMapFromStorage();
    this.getIdFromQuery();
    this.reporter = createReporter(0);
    // 用于处理iframe情况
    this.isIframe = window.self !== window.top;
    this.addListener();
    this.mode = (options === null || options === void 0 ? void 0 : options.mode) || TYPE.DEV;
  }
  return _createClass(Logic, [{
    key: "getIdFromQuery",
    value: function getIdFromQuery() {
      var urlSearchParams = new URLSearchParams(window.location.search);
      var traceid = urlSearchParams.get('traceid');
      var prenode = urlSearchParams.get('prenode');
      if (traceid && prenode) {
        this.traceid = traceid;
        this.prenode = prenode;
        this.setMapToStorage(prenode);
        removeHistoryParameter('traceid');
        removeHistoryParameter('prenode');
      }
    }
  }, {
    key: "setMapToStorage",
    value: function setMapToStorage(prenode) {
      var data = {
        path: location.href,
        traceid: this.traceid,
        prenode: prenode
      };
      sessionStorage.setItem('flowMap', JSON.stringify(data));
    }
  }, {
    key: "getMapFromStorage",
    value: function getMapFromStorage() {
      try {
        var data = JSON.parse(sessionStorage.getItem('flowMap'));
        if (data && data.path === location.href) {
          this.traceid = data.traceid;
          this.prenode = data.prenode;
        }
      } catch (_unused) {
        console.error('flow JSON parse Error');
      }
    }
  }, {
    key: "customUrl",
    value: function customUrl(url) {
      try {
        var searchParams = new URLSearchParams();
        searchParams.append('traceid', this.traceid);
        searchParams.append('prenode', this.prenode);
        var hasParams = url.indexOf('?') !== -1;
        if (hasParams) {
          url += '&' + searchParams.toString();
        } else {
          url += '?' + searchParams.toString();
        }
        return url;
      } catch (_unused2) {
        return url;
      }
    }
  }, {
    key: "getNodeid",
    value: function getNodeid() {
      var random = Math.random();
      var timestamp = Date.now();
      var id = random.toString(36).substr(2, 9) + timestamp;
      return id;
    }
  }, {
    key: "addUser",
    value: function addUser(userid) {
      if (!userid) return;
      this.reporter = createReporter(userid);
    }
  }, {
    key: "addListener",
    value: function addListener() {
      var _this = this;
      window.addEventListener('message', function (event) {
        try {
          if (!(event !== null && event !== void 0 && event.data) || typeof event.data !== 'string') return;
          var data = JSON.parse(event.data);
          var type = data.type,
            nodesid = data.nodesid;
          if (type === 'flow_map') {
            _this.prenode = nodesid;
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
  }, {
    key: "postMessage",
    value: function postMessage(_ref) {
      var nodesid = _ref.nodesid;
      if (this.isIframe) {
        window.parent.postMessage(JSON.stringify({
          type: 'flow_map',
          nodesid: nodesid
        }), '*');
      }
    }
  }, {
    key: "report",
    value: function () {
      var _report = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(flowname, eventname) {
        var mode,
          _localStorage,
          clientName,
          nodesid,
          prenode,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              mode = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'DEV';
              _context.prev = 1;
              clientName = clientApi.getCurrentClient();
              if (!(this.mode === TYPE.USER && mode !== TYPE.USER && mode !== TYPE.ALL)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              nodesid = this.getNodeid(); // 赋值的原因是prenode不用等待接口，不然会导致后面请求拿到的prenode是旧的
              prenode = this.prenode;
              this.prenode = nodesid;
              this.postMessage({
                nodesid: nodesid
              });
              this.setMapToStorage(prenode);
              // 自增
              _context.next = 12;
              return this.reporter('flow_map', {
                flowname: flowname,
                eventname: eventname,
                traceid: Number(this.traceid),
                nodesid: [nodesid, prenode],
                url: location.href,
                time: Date.now(),
                clientName: clientName,
                deviceid: ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('dw_store_device_id_key')) || ''
              });
            case 12:
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              console.log('report error');
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 14]]);
      }));
      function report(_x, _x2) {
        return _report.apply(this, arguments);
      }
      return report;
    }()
  }]);
}();

var init = function init(options) {
  // 用于兼容多个端同时拥有自己的logic，导致上报的node不一致
  if (!window.logic || !(window.logic instanceof Logic)) {
    return new Logic(options);
  } else {
    return window.logic;
  }
};

export { init as default };
